// src/pages/appointments/details/AppointmentCancelDialog.jsx
import React from "react";

export default function AppointmentCancelDialog({
  open,
  title = "Cancel appointment?",
  description = "Are you sure you want to cancel this appointment?",
  cancelText = "No",
  confirmText = "Yes, cancel",
  onCancel,
  onConfirm,
  disableBackdropClose = false,
  textAlign = "center",
  maxWidthClassName = "max-w-[360px]",
}) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4">
      {/* backdrop */}
      <div
        className="absolute inset-0 bg-black/35"
        onClick={disableBackdropClose ? undefined : onCancel}
      />

      <div
        className={[
          "relative w-full rounded-[28px] bg-[rgb(var(--clr-surface-cont-highest))] shadow-[0_12px_40px_rgba(2,6,23,0.18)] overflow-hidden",
          maxWidthClassName,
        ].join(" ")}
        role="dialog"
        aria-modal="true"
      >
        <div className={["px-6 pt-6 pb-5", textAlign === "left" ? "text-left" : "text-center"].join(" ")}>
          <div className="text-headline-small text-on-surface">{title}</div>
          <div className="mt-4 text-body-medium text-on-surface-var">
            {description}
          </div>
        </div>

        <div className="px-5 pb-5 flex gap-3">
          <button
            type="button"
            className="
              flex-1 h-12 rounded-[12px]
              bg-[var(--state-on-surface-08)]
              text-[rgb(var(--afrimed-primary))]
              text-label-large
            "
            onClick={onCancel}
          >
            {cancelText}
          </button>

          <button
            type="button"
            className="
              flex-1 h-12 rounded-[12px]
              bg-[var(--state-critical-12)]
              text-[rgb(var(--schemes-critical))]
              text-label-large
            "
            onClick={onConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}
